"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function DisplayIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M14.082,4.132a7.835,7.835,0,1,0,7.834,7.835A7.844,7.844,0,0,0,14.082,4.132ZM7.947,11.967a6.142,6.142,0,0,1,6.134-6.135V18.1A6.141,6.141,0,0,1,7.947,11.967Z" }),
        react_1.default.createElement("rect", { x: "13.231", y: "0.07", width: "1.7", height: "1.826" }),
        react_1.default.createElement("rect", { x: "5.421", y: "3.249", width: "1.7", height: "1.826", transform: "translate(-1.106 5.655) rotate(-45.011)" }),
        react_1.default.createElement("rect", { x: "2.084", y: "11.083", width: "1.826", height: "1.7" }),
        react_1.default.createElement("rect", { x: "5.264", y: "18.893", width: "1.826", height: "1.7", transform: "translate(-12.152 10.15) rotate(-45)" }),
        react_1.default.createElement("rect", { x: "13.098", y: "22.105", width: "1.7", height: "1.826" })));
}
exports.default = DisplayIcon;
